import { yup } from '@framework/validation';
import { ICreateWidgetFormSchemaInput } from '../../../IWidgetType';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema';
import { IConfirmWidget } from './IConfirmWidget';

export function createConfirmWidgetFormSchema(
  input: ICreateWidgetFormSchemaInput<IConfirmWidget>,
) {
  const schema = yup.number();
  // Non possiamo mettere qui `oneOf` altrimenti la validazione `oneOf`
  // successiva, in `ConfirmWidgetRequired.rule.ts`, non funziona.
  // `oneOf` _aggiunge_ i valori alla lista, non la sostituisce, e in
  // invio dobbiamo avere solo (Modified | Confirmed).
  // .oneOf([
  //   ConfirmWidgetValue.Unconfirmed,
  //   ConfirmWidgetValue.Modified,
  //   ConfirmWidgetValue.Confirmed
  // ]);

  return createCommonFormSchema(schema, input.widget);
}
